import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import Swal from "sweetalert2";

@Component({
  selector: 'app-plantillas',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './plantillas.component.html',
  styleUrl: './plantillas.component.css'
})
export class PlantillasComponent implements OnInit, OnChanges {
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;
  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  @Output() programaClienteActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  listaPlantillas: any = [];
  plantillaSeleccionada: any;
  seccionSeleccionada: 'instrucciones'|'alimentacion'|'pestanaLateral'|'ejercicio'|'progreso'|'gestionEstres' = 'instrucciones';
  contenidoSanitizado: SafeHtml;
  
  plantillasSeleccionadas: any = {
    instrucciones:  {},
    alimentacion:   [],
    pestanaLateral: {},
    ejercicio:      [],
    progreso:       [],
    gestionEstres:  []
  }

  constructor(
    private documentService: DocumentsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getPlantillas();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.sanitizarContenido();
    console.log("detallePrograma", this.detallePrograma)
    console.log("detalleCliente", this.detalleCliente)
  
    // Reinicia plantillasSeleccionadas para evitar acumulaciones no deseadas
    this.plantillasSeleccionadas = {
      instrucciones: {},
      alimentacion: [],
      pestanaLateral: {},
      ejercicio: [],
      progreso: [],
      gestionEstres: [],
    };

    let index;
    if(this.detalleCliente) index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
    if (this.detallePrograma?.plantillas || this.detalleCliente?.expediente.programas[index].configuracionPrograma.plantillas) {
      const seccionesMap: { [key: string]: string } = {
        'Instrucciones'   : 'instrucciones',
        'Alimentacion'    : 'alimentacion',
        'Pestaña Lateral' : 'pestanaLateral',
        'Ejercicio'       : 'ejercicio',
        'Progreso'        : 'progreso',
        'Gestión del estrés': 'gestionEstres',
      };
      let arrayPlantillas: any = this.detalleCliente && this.detallePrograma.tipo == '1' ? 
        (this.detalleCliente?.expediente.programas[index].configuracionPrograma.plantillas || []) : 
        this.detallePrograma?.plantillas;
      // Asigna las plantillas a la sección correspondiente
      for (let plantilla of arrayPlantillas) {
        const key = seccionesMap[plantilla.seccion];
        if (key) {
          if (Array.isArray(this.plantillasSeleccionadas[key])) {
            // this.plantillasSeleccionadas[key].push(plantilla.plantillas);
            this.plantillasSeleccionadas[key] = plantilla.plantillas;
          } else {
            this.plantillasSeleccionadas[key] = plantilla.plantilla;
          }
        }
      }
    }
    // console.log('plantillasSeleccionadas', this.plantillasSeleccionadas);
  }

  guardarCambios() {
    let plantillas: any = [
      {
        seccion: 'Instrucciones',
        plantilla: this.plantillasSeleccionadas.instrucciones
      },
      {
        seccion: 'Alimentacion',
        plantillas: this.plantillasSeleccionadas.alimentacion
      },
      {
        seccion: 'Pestaña Lateral',
        plantilla: this.plantillasSeleccionadas.pestanaLateral
      },
      {
        seccion: 'Ejercicio',
        plantillas: this.plantillasSeleccionadas.ejercicio
      },
      {
        seccion: 'Progreso',
        plantillas: this.plantillasSeleccionadas.progreso
      },
      {
        seccion: 'Gestión del estrés',
        plantillas: this.plantillasSeleccionadas.gestionEstres
      }
    ]
    if(this.detallePrograma.tipo == '1') {
      this.updateClienteDocument(plantillas);
    } else if(this.detallePrograma.tipo == '2') {
      this.updateProgramaDocument(plantillas);
    }
  }
  updateClienteDocument(plantillas) {
    const index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
    let programas = [...this.detalleCliente.expediente.programas];
    programas[index].configuracionPrograma.plantillas = plantillas;
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    console.log('expedienteClienteDocument', expedienteClienteDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'La información del programa ha sido actualizada.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });

        // Emitir el evento hacia el padre
        this.programaClienteActualizado.emit();
      }
    })
  }
  
  updateProgramaDocument(plantillas) {
    let programaDocument: any = {
      plantillas: plantillas
    }
    console.log('programaDocument', programaDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'La información del programa ha sido actualizada.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });

        // Emitir el evento hacia el padre
        this.programaActualizado.emit();
      }
    })
  }

  sanitizarContenido(): void {
    this.contenidoSanitizado = this.sanitizer.bypassSecurityTrustHtml(this.plantillaSeleccionada?.contenidoPlantilla);
  }
  getPlantillas(){
    this.documentService.getDocumentsByType(
        environment.businessId,
        this.userInfo.documentContainerId,
        "plantilla"
    ).subscribe({
      next: (data: any) => {
        this.listaPlantillas = [...data.content];
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  onChangePlantillaSeleccionada(plantilla: any)
  {
    console.log(plantilla)
    this.plantillaSeleccionada = plantilla;
    this.sanitizarContenido();
  }

  onChangeSelectPlantilla(plantilla: any, seccion: string, esMultiple: boolean) {
    console.log("<======= onChangeSelectPlantilla ======>")
    console.log(plantilla.nombrePlantilla, plantilla.documentId);
    if (esMultiple) {
      const index = this.plantillasSeleccionadas[seccion].indexOf(plantilla.documentId);
      if (index === -1) {
        // Si no está seleccionado, lo añadimos
        this.plantillasSeleccionadas[seccion].push(plantilla.documentId);
      } else {
        // Si ya está seleccionado, lo eliminamos
        this.plantillasSeleccionadas[seccion].splice(index, 1);
      }
    } else {
      // Asignamos directamente para radio buttons
      this.plantillasSeleccionadas[seccion] = plantilla.documentId;
    }
    this.guardarCambios();
    console.log(this.plantillasSeleccionadas);
  }
  
  isPlantillaSeleccionada(documentId: string, seccion: string): boolean {
    return this.plantillasSeleccionadas[seccion].includes(documentId);
  }
}
